import { Grid, Skeleton } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';

interface SurveyResponseDataProps {
    response: any;
    loading: boolean;
}

export const SurveyResponseData = ({
    response,
    loading,
}: SurveyResponseDataProps) => {
    if (loading) {
        return (
            <Grid container spacing={2}>
                {[...Array(8)].map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Skeleton variant="rectangular" height={56} />
                    </Grid>
                ))}
            </Grid>
        );
    }

    if (!response) {
        return <div>No se encontró la respuesta</div>;
    }

    const getStatusLabel = (status: string) => {
        return status === 'completed' ? 'Completada' : 'Incompleta';
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código Encuesta"
                    name="survey_code"
                    size="small"
                    value={response.survey?.code || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Encuesta"
                    name="survey_title"
                    size="small"
                    value={response.survey?.title || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Estado"
                    name="status"
                    size="small"
                    value={getStatusLabel(response.status)}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Caller ID"
                    name="caller_id"
                    size="small"
                    value={response.caller_id || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de Documento"
                    name="document_number"
                    size="small"
                    value={response.document_number || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nombre Cliente"
                    name="customer_name"
                    size="small"
                    value={response.customer_name || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Servicio Asociado"
                    name="associated_service"
                    size="small"
                    value={response.associated_service || '-'}
                    onChange={undefined}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha de Creación"
                    name="created_at"
                    size="small"
                    value={
                        response.created_at
                            ? new Date(response.created_at).toLocaleString(
                                'es-CO'
                            )
                            : '-'
                    }
                    onChange={undefined}
                />
            </Grid>
            {response.completed_at && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Fecha de Finalización"
                        name="completed_at"
                        size="small"
                        value={new Date(response.completed_at).toLocaleString(
                            'es-CO'
                        )}
                        onChange={undefined}
                    />
                </Grid>
            )}
        </Grid>
    );
};
